import css from './Form.module.scss'
import React, { PropsWithChildren } from 'react'
import { Form as FormikForm, Formik } from 'formik'

import { RequestMethod } from 'meta/api/requestMethod'

import FormButtonSubmit from './FormButtonSubmit'
import FormContext from './FormContext'
import FormError from './FormError'
import FormFields from './FormFields'
import { useInitialValues, useOnSubmit, useValidationSchema } from './hooks'
import { IFormContext, IFormProps } from './types'

const defaultFormContextRef: React.RefObject<IFormContext<object>> = React.createRef<IFormContext<object>>()

const Form: React.FC<PropsWithChildren<IFormProps>> = (props) => {
  const {
    children,
    formContextRef = defaultFormContextRef,
    formFields,
    id,
    labelSubmit,
    renderError = true,
    renderFields = true,
    requestMethod = RequestMethod.post,
    ...rest
  } = props

  const initialValues = useInitialValues({ ...props, requestMethod })
  const validationSchema = useValidationSchema({ ...props, requestMethod })
  const { onSubmit, error } = useOnSubmit({ ...props, requestMethod })

  return (
    <div className={css.formWrapper}>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
        <FormikForm id={id} data-testid={id} className={css.form} {...rest}>
          {/* @ts-ignore */}
          <FormContext formContextRef={formContextRef} />

          {renderError && <FormError error={error} />}

          {renderFields && (
            <>
              <FormFields formFields={formFields} />
              <FormButtonSubmit labelSubmit={labelSubmit} />
            </>
          )}

          {React.Children.toArray(children)}
        </FormikForm>
      </Formik>
    </div>
  )
}

export default Form
